import "@/App.css";
import "@/styles/marketing.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MarketingHome from "@/pages/MarketingHome";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MarketingHome />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
